export default __webpack_public_path__ + "static/media/gscLogo.d2860a9c.svg";